/* Cart Milestone logic */
class CartMilestone {
  constructor() {
    this.isUpdating = false;
    this.isFirstRun = true;
    this.THRESHOLDS = [5000, 10000]; // Default thresholds
    this.init();
  }

  init() {
    console.log('Initializing Cart Milestone');
    
    // Read thresholds on init
    this.readThresholdsFromDOM();
    
    // Set up all possible events that might indicate cart changes
    this.setupEventListeners();
    
    // Initialize as soon as elements are available
    this.initializeWhenReady();
  }

  // Set up all possible events
  setupEventListeners() {
    // Standard cart events
    document.addEventListener('cart:updated', () => this.triggerUpdate());
    document.addEventListener('cart:refresh', () => this.triggerUpdate());
    document.addEventListener('cart:change', () => this.triggerUpdate());
    
    // Cart drawer events
    document.addEventListener('drawer:open', (event) => {
      if (event.detail && event.detail.id === 'cart') {
        this.triggerUpdate();
      }
    });
    document.addEventListener('cartdrawer:opened', () => this.triggerUpdate());
    
    // Form submission & button clicks (for add to cart actions)
    document.addEventListener('submit', (event) => {
      if (event.target && event.target.action && 
          event.target.action.includes('/cart/add')) {
        setTimeout(() => this.triggerUpdate(), 500);
      }
    });
    
    // Click on add to cart buttons
    document.addEventListener('click', (event) => {
      if (event.target && (
          event.target.classList.contains('add-to-cart') || 
          event.target.closest('.add-to-cart') ||
          event.target.getAttribute('name') === 'add' ||
          (event.target.getAttribute('type') === 'submit' && 
           event.target.closest('form[action*="/cart/add"]'))
        )) {
        setTimeout(() => this.triggerUpdate(), 500);
      }
    });
    
    // AJAX completion events
    document.addEventListener('ajax:complete', (event) => {
      if (event.detail && event.detail.requestUrl && 
          (event.detail.requestUrl.includes('/cart/add') || 
           event.detail.requestUrl.includes('/cart/update') ||
           event.detail.requestUrl.includes('/cart/change'))) {
        setTimeout(() => this.triggerUpdate(), 300);
      }
    });
    
    // Intercept fetch for modern cart APIs
    this.interceptFetch();
    
    // Add the DOMContentLoaded event
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.triggerUpdate());
    } else {
      // DOM already loaded, initialize immediately
      this.triggerUpdate();
    }
  }

  // Intercept fetch requests to detect cart changes
  interceptFetch() {
    const originalFetch = window.fetch;
    const self = this;
    
    window.fetch = function(url, options) {
      const promise = originalFetch.apply(this, arguments);
      
      if (url && typeof url === 'string' && 
          (url.includes('/cart/add') || 
           url.includes('/cart/update') || 
           url.includes('/cart/change'))) {
        promise.then(() => {
          setTimeout(() => self.triggerUpdate(), 300);
        });
      }
      
      return promise;
    };
  }

  // Trigger update with debouncing
  triggerUpdate() {
    if (this._updateTimeout) clearTimeout(this._updateTimeout);
    
    this._updateTimeout = setTimeout(() => {
      this.readThresholdsFromDOM();
      this.updateMilestone();
    }, 200);
  }

  // In the readThresholdsFromDOM method, replace the existing method with this:

readThresholdsFromDOM() {
  const milestone = document.querySelector('.cart-milestone');
  if (!milestone) return;
  
  try {
    // Try to get thresholds from data attribute
    const thresholdsStr = milestone.getAttribute('data-thresholds');
    
    if (thresholdsStr && thresholdsStr.trim() !== '' && thresholdsStr !== 'null') {
      try {
        // First try parsing as JSON
        const parsed = JSON.parse(thresholdsStr);
        
        if (Array.isArray(parsed) && parsed.length > 0) {
          // Convert strings to numbers and filter out invalid values
          const numericThresholds = parsed.map(item => {
            const num = typeof item === 'string' ? parseFloat(item.trim()) : parseFloat(item);
            return isNaN(num) ? null : num;
          }).filter(item => item !== null && item > 0);
          
          if (numericThresholds.length > 0) {
            this.THRESHOLDS = numericThresholds;
            return;
          }
        }
      } catch (jsonError) {
        // If JSON parsing fails, try comma-separated values
        if (thresholdsStr.includes(',')) {
          const values = thresholdsStr.split(',')
                                    .map(item => parseFloat(item.trim()))
                                    .filter(item => !isNaN(item) && item > 0);
          
          if (values.length > 0) {
            this.THRESHOLDS = values;
            return;
          }
        } else {
          // Single value
          const singleValue = parseFloat(thresholdsStr.trim());
          if (!isNaN(singleValue) && singleValue > 0) {
            this.THRESHOLDS = [singleValue];
            return;
          }
        }
      }
    }
  } catch (error) {
    console.error('Error reading thresholds:', error);
  }
}

  initializeWhenReady() {
    const waitForCart = () => {
      // Look for different possible selectors for cart subtotal
      const subtotalElement = 
        document.getElementById('mini-cart-subtotal') || 
        document.querySelector('.cart-subtotal__price') ||
        document.querySelector('[data-cart-subtotal]') ||
        document.querySelector('.cart__subtotal');
      
      const milestone = document.querySelector('.cart-milestone');
      
      if (milestone && subtotalElement) {
        console.log('Cart elements found, initializing milestone');
        
        // Initial update
        this.updateMilestone();
        
        // Set up observer for subtotal changes
        const observer = new MutationObserver(() => {
          if (!this.isUpdating) {
            setTimeout(() => this.updateMilestone(), 100);
          }
        });
        
        observer.observe(subtotalElement, {
          subtree: true,
          childList: true,
          characterData: true
        });
      } else {
        // Keep checking until cart elements are available
        setTimeout(waitForCart, 100);
      }
    };

    waitForCart();
  }

  getCartTotal() {
  try {
    // Try multiple possible selectors for cart subtotal
    const subtotalElement = 
      document.getElementById('mini-cart-subtotal') || 
      document.querySelector('.cart-subtotal__price') ||
      document.querySelector('[data-cart-subtotal]') ||
      document.querySelector('.cart__subtotal');
    
    if (!subtotalElement) return 0;
    
    // Check if there's a crossed-out price element (original price)
    const crossedOutElement = subtotalElement.querySelector('.cross-cart-price');
    
    if (crossedOutElement) {
      // There's a discount - use the crossed-out price (original price)
      const originalPriceText = crossedOutElement.textContent.trim();
      const priceMatch = originalPriceText.match(/[₹$€£¥]\s*([\d,]+\.?\d*)/);
      
      if (priceMatch) {
        const cleanPrice = priceMatch[1].replace(/,/g, '');
        const numericPrice = parseFloat(cleanPrice);
        return isNaN(numericPrice) ? 0 : numericPrice;
      }
    } else {
      // No discount - use the regular price (which is the original price)
      const priceText = subtotalElement.textContent.trim();
      const priceMatch = priceText.match(/[₹$€£¥]\s*([\d,]+\.?\d*)/);
      
      if (priceMatch) {
        const cleanPrice = priceMatch[1].replace(/,/g, '');
        const numericPrice = parseFloat(cleanPrice);
        return isNaN(numericPrice) ? 0 : numericPrice;
      }
    }
    
    return 0;
  } catch (error) {
    console.error('Error getting cart total:', error);
    return 0;
  }
}

  updateMilestone() {
    if (this.isUpdating) return;
    
    try {
      this.isUpdating = true;
      
      const milestone = document.querySelector('.cart-milestone');
      if (!milestone) {
        this.isUpdating = false;
        return;
      }
      
      const currentTotal = this.getCartTotal();
      console.log('Cart total detected:', currentTotal);
      
      // Skip update if cart is empty
      if (currentTotal === 0) {
        this.isUpdating = false;
        return;
      }
      
      // Determine current milestone level based on thresholds
      let currentMilestone = 0;
      for (let i = 0; i < this.THRESHOLDS.length; i++) {
        if (currentTotal >= this.THRESHOLDS[i]) {
          currentMilestone = i + 1;
        }
      }
      
      // Store the current total and milestone as data attributes
      milestone.setAttribute('data-current-total', currentTotal);
      milestone.setAttribute('data-current-milestone', currentMilestone);
      milestone.setAttribute('data-thresholds-json', JSON.stringify(this.THRESHOLDS));
      
      // Calculate progress (0-100)
      let progress;
      if (currentMilestone === this.THRESHOLDS.length) {
        // All thresholds met
        progress = 100;
      } else if (currentMilestone > 0) {
        // Between thresholds
        const prevThreshold = this.THRESHOLDS[currentMilestone - 1];
        const nextThreshold = this.THRESHOLDS[currentMilestone] || this.THRESHOLDS[this.THRESHOLDS.length - 1];
        // For the classic two-milestone system with 50% per milestone
        if (this.THRESHOLDS.length === 2) {
          progress = 50 + ((currentTotal - prevThreshold) / (nextThreshold - prevThreshold) * 50);
        } else {
          // For dynamic number of milestones
          const segmentSize = 100 / this.THRESHOLDS.length;
          const baseProgress = segmentSize * currentMilestone;
          const additionalProgress = ((currentTotal - prevThreshold) / (nextThreshold - prevThreshold)) * segmentSize;
          progress = baseProgress + additionalProgress;
        }
      } else {
        // Below first threshold
        if (this.THRESHOLDS.length === 2) {
          // Classic two-milestone system
          progress = (currentTotal / this.THRESHOLDS[0]) * 50;
        } else {
          // Dynamic number of milestones
          progress = (currentTotal / this.THRESHOLDS[0]) * (100 / this.THRESHOLDS.length);
        }
      }

      // Apply progress to the fill element
      const progressFill = milestone.querySelector('.progress-fill');
      if (progressFill) {
        // Set the width with CSS transition (animation will happen automatically)
        // The key is NOT to manipulate the transition property here
        progressFill.style.width = `${progress}%`;
      }

      // Update remaining amount placeholders in messages
      const updateRemainingAmount = (selector, threshold) => {
        const elements = milestone.querySelectorAll(selector);
        const remaining = Math.max(0, threshold - currentTotal);
        elements.forEach(el => {
          if (el) el.textContent = Math.ceil(remaining).toLocaleString('en-IN');
        });
      };

      // Update all possible remaining amounts
      for (let i = 0; i < this.THRESHOLDS.length; i++) {
        updateRemainingAmount(`.remaining-amount-${i+1}`, this.THRESHOLDS[i]);
      }
      
      // Also update generic remaining amount classes
      updateRemainingAmount('.remaining-amount', this.THRESHOLDS[0]);
      updateRemainingAmount('.remaining-amount-final', this.THRESHOLDS[this.THRESHOLDS.length - 1]);

      // Update message visibility 
      const messages = milestone.querySelectorAll('.milestone-message > span');
      messages.forEach(msg => {
        msg.style.display = 'none';
      });

      // Show current milestone message
      let currentMessage;
      if (currentMilestone === this.THRESHOLDS.length) {
        currentMessage = milestone.querySelector('.message-achieved');
      } else if (currentMilestone > 0) {
        currentMessage = milestone.querySelector(`.message-partial-${currentMilestone}`);
        if (!currentMessage) {
          // Fallback to generic partial message if specific one doesn't exist
          currentMessage = milestone.querySelector('.message-partial');
        }
      } else {
        currentMessage = milestone.querySelector('.message-default');
      }
      
      if (currentMessage) {
        currentMessage.style.display = 'block';
      }

      // Update checkpoints
      const checkpoints = milestone.querySelectorAll('.milestone-checkpoint');
      checkpoints.forEach((checkpoint) => {
        const checkpointMilestone = parseInt(checkpoint.getAttribute('data-milestone') || '0');
        const achieved = currentMilestone >= checkpointMilestone;
        checkpoint.setAttribute('data-achieved', achieved.toString());
      });

    } catch (error) {
      console.error('Error updating milestone:', error);
    } finally {
      this.isUpdating = false;
    }
  }
}

// Create and store a single instance
let cartMilestoneInstance = null;

function initCartMilestone() {
  if (!cartMilestoneInstance) {
    console.log('Creating cart milestone instance');
    cartMilestoneInstance = new CartMilestone();
  } else {
    console.log('Using existing cart milestone instance');
    cartMilestoneInstance.triggerUpdate();
  }
  return cartMilestoneInstance;
}

// Initialize when the script loads
initCartMilestone();

// Add a global function for manual initialization
window.initCartMilestone = initCartMilestone;